import React from 'react';
import { fontSize, palette } from '../..';
import FileDropZone from './FileDropZone';
import HoverButton from '../Buttons/HoverButton';
import { ffButtonStyle } from './muiStyles';
import jsonFileIcon from '../../assets/jsonFileIcon.png';
import csvFileIcon from '../../assets/csvFileIcon.png';
import xlsxFileIcon from '../../assets/xlsxFileIcon.png';
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useLocation } from 'react-router-dom';

// File type options configuration
export const FILE_TYPES = [
  { id: 'csv', icon: csvFileIcon, label: 'CSV' },
  { id: 'json', icon: jsonFileIcon, label: 'JSON' },
  { id: 'excel', icon: xlsxFileIcon, label: 'EXCEL' },
];

interface FileTypeSelectorProps {
  selectedFileType: string | undefined;
  onFileTypeSelect: (fileType: string) => void;
}

export const FileTypeSelector: React.FC<FileTypeSelectorProps> = ({
  selectedFileType,
  onFileTypeSelect,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className="rightsidebar-container"
      style={{
        borderRight: '2px solid rgb(224, 224, 224)',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
      }}
    >
      <h2
        className="header"
        style={{
          fontSize: fontSize.large,
          color: palette.primary.contrastText,
          fontWeight: 'bold',
        }}
      >
        Select a File Type
      </h2>

      <div className="icon-container">
        {FILE_TYPES.map(({ id, icon, label }) => (
          <div
            key={id}
            className={`${id}-container ${selectedFileType === id ? 'selected-container' : ''}`}
            style={{ display: 'flex' }}
            onClick={() => onFileTypeSelect(id)}
          >
            <div className={`${id}-icon`}>
              <img src={icon} className={`${id}-img`} alt={label} />
            </div>
            <div>
              <p style={{ fontSize: fontSize.medium, color: palette.primary.contrastText }}>
                {label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

interface UploadAreaProps {
  selectedFileType: string | undefined;
  selectedFile: File | undefined;
  handleFileSelect: (file: File | undefined) => void;
  handleSubmit: (event: React.FormEvent) => void;
  mode: boolean;
}

export const UploadArea: React.FC<UploadAreaProps> = ({
  selectedFileType,
  selectedFile,
  handleFileSelect,
  handleSubmit,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  if (!selectedFileType) {
    return (
      <div className="select-container">
        <p
          style={{
            fontSize: fontSize.medium,
            color: palette.primary.contrastText,
            fontWeight: 'bold',
          }}
        >
          Select a File Type
        </p>
        <div
          style={{
            position: 'absolute',
            top: '54px',
            left: '275px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            zIndex: 10,
          }}
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon style={{ marginRight: '5px' }} />
          <span
            style={{
              fontSize: fontSize.medium,
              fontWeight: 'bold',
              color: 'grey',
            }}
          >
            Back
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="FileUploadContainer">
      <div
        className="uploadFileTitle"
        style={{
          fontSize: fontSize.large,
          color: palette.primary.contrastText,
          fontWeight: 'bold',
        }}
      >
        Upload {selectedFileType.toUpperCase()} File
      </div>
      <FileDropZone
        setSelectedFile={handleFileSelect}
        selectedFile={selectedFile}
        fileType={selectedFileType}
      />
      <div
        className="file-upload-button-container"
        style={
          {
            // border: '1px solid #e0e0e0',
          }
        }
      >
        <HoverButton
          onClick={handleSubmit}
          text="Upload"
          color="primary.main"
          hoverColor="secondary.contrastText"
          backgroundColor="secondary.contrastText"
          hoverBackgroundColor="primary.main"
          transitionTime="0.2s"
          sx={{
            ...ffButtonStyle,
            height: '2.5rem',
            border: `1px solid ${palette.primary.main}`,
            fontSize: fontSize.medium,
            lineHeight: 'normal',
            width: '90px',
          }}
        />

        {state?.mode === 'update' && (
          <div
            style={{
              color: 'gray',
              marginTop: '8px',
              fontSize: fontSize.semiLarge,
            }}
          >
            Make sure new file contains all columns that were uploaded before.
          </div>
        )}
      </div>
    </div>
  );
};

interface ErrorDialogProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, message, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="dialog-container">
        <DialogTitle className="dialog-title">ERROR!</DialogTitle>
        <DialogContentText
          className="dialog-content-text"
          sx={{
            display: 'flex',
            textAlign: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            paddingLeft: ' 20px',
            paddingRight: '20px',
            paddingBottom: '5px',
          }}
        >
          {message}
        </DialogContentText>
        <DialogActions className="dialog-actions">
          <Button
            onClick={onClose}
            className="dialog-button"
            sx={{
              color: 'gray',
              border: '1px solid gray',
              marginBottom: '10px',
              marginRight: '15px',
              '&:hover': {
                backgroundColor: ' #8c6bb1',
                color: 'white',
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
